/* ==========================================================================
   LEGIT × LOOP SUBSCRIPTIONS — PDP widget "Subscription details" enhancement
   --------------------------------------------------------------------------
   Loop's PDP subscription widget shows "Subscription details" as a hover/tap
   tooltip at the bottom. This moves that same content into an inline, open-by-
   default collapsible BETWEEN the One-time and Subscribe options, and hides the
   tooltip — the same pattern as the bundle builder's "Why subscribe" block.

   Loaded from the theme on product pages (see sections/product.liquid). Loop
   re-renders the widget on variant change, wiping injected nodes, so we watch
   the DOM. SAFETY: the observer is DISCONNECTED before we touch the DOM and
   reconnected after — it can never retrigger itself.

   Edit SUMMARY_LABEL / OPEN_BY_DEFAULT below.
   ========================================================================== */
(function () {
  'use strict';

  var SUMMARY_LABEL   = 'Subscription details';
  var OPEN_BY_DEFAULT = false;

  /* remember the shopper's collapse choice for the session (null = default) */
  var userToggled = null;

  function buildDetails(contentNodes) {
    var d = document.createElement('details');
    d.className = 'legit-subdetails';
    d.setAttribute('data-legit-subdetails', '');
    d.open = (userToggled === null) ? OPEN_BY_DEFAULT : userToggled;
    d.innerHTML =
      '<summary class="legit-subdetails__summary">' +
        '<span class="legit-subdetails__eyebrow">' + SUMMARY_LABEL + '</span>' +
        '<span class="legit-subdetails__chev" aria-hidden="true"></span>' +
      '</summary>' +
      '<div class="legit-subdetails__body"></div>';
    var body = d.querySelector('.legit-subdetails__body');
    contentNodes.forEach(function (n) { body.appendChild(n.cloneNode(true)); });
    d.addEventListener('toggle', function () { userToggled = d.open; });
    return d;
  }

  function inject() {
    var widgets = document.querySelectorAll('.loop-widget-container');
    Array.prototype.forEach.call(widgets, function (w) {
      var opts = w.querySelector('.loop-widget-purchase-options-container');
      if (!opts) return;
      var tooltip = w.querySelector('.loop-widget-tooltip-container');

      /* already injected → just keep Loop's tooltip hidden and stop */
      if (opts.querySelector('[data-legit-subdetails]')) {
        if (tooltip) tooltip.classList.add('legit-hide');
        return;
      }
      if (!tooltip) return;                       /* no details content to move */

      var text = tooltip.querySelector('.loop-widget-tooltip-text');
      if (!text) return;
      /* the content minus the little tooltip pointer arrow */
      var nodes = Array.prototype.filter.call(text.children, function (c) {
        return !(c.classList && c.classList.contains('loop-widget-container-arrow'));
      });
      if (!nodes.length) return;

      var details = buildDetails(nodes);
      var oneTime = opts.querySelector('.loop-widget-purchase-option-onetime');
      if (oneTime) oneTime.insertAdjacentElement('afterend', details);   /* between the options */
      else opts.insertBefore(details, opts.firstChild);                  /* subscribe-only fallback */

      tooltip.classList.add('legit-hide');
    });
  }

  /* --- observer: disconnect before mutating, reconnect after; rAF-batched --- */
  var observer = null, queued = false;

  function run() {
    queued = false;
    if (observer) observer.disconnect();
    try { inject(); }
    catch (e) { if (window.console) console.warn('[legit-loop-subscriptions]', e); }
    finally { if (observer) observer.observe(document.body, { childList: true, subtree: true }); }
  }
  function schedule() { if (queued) return; queued = true; window.requestAnimationFrame(run); }

  function start() {
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    run();
    /* Loop renders asynchronously (retrying startLoopWidget) — catch late mounts */
    setTimeout(run, 500);
    setTimeout(run, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
